import { render, staticRenderFns } from "./Seguro.vue?vue&type=template&id=1a68a0b1&"
import script from "./Seguro.vue?vue&type=script&lang=js&"
export * from "./Seguro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports